module.exports = __webpack_public_path__ + "static/bohatery-8ebd129826af934c46b6fac71acc049e.png";